import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import RatingStars from 'components/Common/RatingStars'
import Group from 'components/utils/Group'
import facebookLogo from './facebook-logo.svg'
import Caption from 'LuxKit/Typography/Caption'

const Wrapper = styled(Group)`
  margin-top: ${rem(8)}; /* DO NOT APPLY MARGIN ON INDIVIDUAL ROOT ELEMENT */
`

const StyledImg = styled.img`
  max-width:100%;
  display: block;
`

interface Props {
  prefix?: string
}

function SocialStars(props: Props) {
  const { prefix } = props
  return <Wrapper direction="vertical" horizontalAlign="center">
    <Group
      direction="horizontal"
      horizontalAlign="center"
      gap={8}
      verticalAlign="baseline"
    >
      <div style={{ width: '80px' }}>
        {/*  No need for i18n since its a brand name */}
        <StyledImg src={facebookLogo} alt="Facebook" />
      </div>
      <div>
        <RatingStars color="#4667AA" maskWidth={111} maskId={prefix ? `facebook-${prefix}` : 'facebook'} width={69} height={13} />
      </div>
    </Group>
    <Caption variant="medium" align="center">
      <FormattedMessage
        id="B0bWcEeKrM"
        defaultMessage="<strong>1.4 million people </strong>like us"
        description="Social proof text showing how many people like us on Facebook"
        values={{ strong: (chunks: React.ReactNode) => <strong>{chunks}</strong> }}
      />
    </Caption>
  </Wrapper>
}

export default SocialStars
